import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Hsection1cs.css";
import "./Component.css";
import LoadingImage from "./Loadingimage";
const CarSection = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Attach the event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const fadeInLeft = useRef(null);

  useEffect(() => {
    const fadeInLeftRef = fadeInLeft.current;
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.8, // Jumlah tampilan elemen dalam viewport yang dibutuhkan untuk memanggil class
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Ketika elemen masuk ke dalam viewport
          entry.target.classList.add("fade-in-left"); // Tambahkan class yang diinginkan
        }
      });
    }, options);

    if (fadeInLeftRef) {
      observer.observe(fadeInLeftRef);
    }
    return () => {
      if (fadeInLeftRef) {
        observer.unobserve(fadeInLeftRef);
      }
    };
  }, []);
  const fadeInRight = useRef(null);
  useEffect(() => {
    const fadeInRightRef = fadeInRight.current;
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5, // Jumlah tampilan elemen dalam viewport yang dibutuhkan untuk memanggil class
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Ketika elemen masuk ke dalam viewport
          entry.target.classList.add("fade-in-right"); // Tambahkan class yang diinginkan
        }
      });
    }, options);
    if (fadeInRightRef) {
      observer.observe(fadeInRightRef);
    }

    return () => {
      if (fadeInRightRef) {
        observer.unobserve(fadeInRightRef);
      }
    };
  }, []);
  return (
    <div className="car-section">
      {/* Section 1 */}
      <Container className="section-one section-size">
        <Row
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Col
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            className="car-image-col hidden"
            ref={fadeInLeft}
          >
            <LoadingImage
              src="https://i.ibb.co.com/v4tpwF1/car-detailing-2.webp"
              alt="man-detailing-car"
              className={"car-image"}
            />
          </Col>
          <Col
            className="content hidden"
            ref={fadeInRight}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="text-wecarcare1 roleway">
              <h1
                style={{
                  textAlign: isMobile ? "center" : "start",
                }}
              >
                {localStorage.getItem("bahasa") === "ing"
                  ? "RPM : Where Professionalism Meets Automotive Passion"
                  : "RPM : Saat Profesionalisme Bertemu Gairah Otomotif"}
              </h1>
              <p
                className="nunito mb-0"
                style={{
                  textAlign: "justify",
                  fontWeight: "400",
                }}
              >
                {localStorage.getItem("bahasa") === "ing" ? (
                  <>
                    <b>More Than Just a Workshop, We Are Your Journey Partner</b>
                    <br />
                    Welcome to PT. Raja Perkasa Motor (RPM). Since 2019, we believe that every vehicle has a soul and a story. For us, automotive is not just about machines and metal, but a blend of art, technology, and pride for its owner.
                    <br />
                    At RPM, we unite rigid and precise professional work standards with unlimited automotive passion. The result? A comprehensive service that not only repairs but also values every detail of your vehicle.
                  </>
                ) : (
                  <>
                    <b>Lebih dari Sekadar Bengkel, Kami Adalah Partner Perjalanan Anda</b>
                    <br />
                    Selamat datang di PT. Raja Perkasa Motor (RPM). Sejak tahun 2019, kami percaya bahwa setiap kendaraan memiliki jiwa dan cerita. Bagi kami, otomotif bukan sekadar mesin dan logam, melainkan perpaduan antara seni, teknologi, dan kebanggaan bagi pemiliknya.
                    <br />
                    Di RPM, kami menyatukan standar kerja profesional yang kaku dan presisi dengan gairah (passion) otomotif yang tak terbatas. Hasilnya? Sebuah layanan terpadu yang tidak hanya memperbaiki, tetapi juga menghargai setiap detail kendaraan Anda.
                  </>
                )}
              </p>
              {/* <button
                className="btn btn-detail nunito"
                style={{ backgroundColor: "#ff0000" }}
              >
                Lihat Detail
              </button> */}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CarSection;
